import { z } from "zod";

// Zod schema lives here (not in @repo/common) because @repo/db cannot depend
// on @repo/common. @repo/common re-exports ThirdPartyEvidence as z.infer of
// this schema, so there is a single source of truth.
export const thirdPartyEvidenceSchema = z.object({
  provider: z.string(),
  result: z.enum(["completed", "screened_out", "rejected", "quota_full"]),
  receivedAt: z.string(),
  callbackUrl: z.string().optional(),
  rawParams: z.record(z.string()).optional(),
});

/**
 * What a FILE_UPLOAD task collected, written by `submitTaskFiles`. The files
 * themselves live in `SubmissionTaskFileUpload`; this records which of them the
 * expert actually submitted, so a later soft-delete or a re-opened task can't
 * silently change what was reviewed. Mirrors `fileUploadScreeningResultSchema`.
 */
export const fileUploadTaskResultSchema = z.object({
  fileIds: z.array(z.string()),
  submittedAt: z.string().datetime(),
});

export type FileUploadTaskResult = z.infer<typeof fileUploadTaskResultSchema>;

export const taskResultSchema = z.object({
  evidence: z.array(thirdPartyEvidenceSchema).optional(),
  fileUpload: fileUploadTaskResultSchema.optional(),
});

export type TaskResult = z.infer<typeof taskResultSchema>;
